import '../../styles/HomeButtons.css';

function HomeButtons({ activeSection, onSectionChange }) {
    const sections = [
        { key: 'news', label: 'Updates' }
    ];

    return (
        <div className="home-buttons">
            {sections.map((section) => (
                <button
                    key={section.key}
                    className={`home-button ${activeSection === section.key ? "active" : ""}`}
                    onClick={() => onSectionChange(section.key)}
                >
                    {section.label}
                </button>
            ))}
        </div>
    );
}

export default HomeButtons;